import customerApi from '../../components/apis/customerApi';

export function getHomePageContent() {
  return customerApi.get('/api/page-content/home').then((res) => res.data);
}

export function getProfilePageContent() {
  return customerApi.get('/api/page-content/profile').then((res) => res.data);
}
